import './streamResponseRecorderGlobals';

/**
 * Returns the recorded stream response messages as newline-delimited JSON strings.
 *
 * Wrapped in a try/catch because accessing properties on `window.top` can throw a
 * `SecurityError` when the caller is in a cross-origin iframe (e.g. the Rovo Chrome
 * Extension side panel). See ASIMO-3773 / PIR-300295.
 */
export const getStreamResponseOutput = (): string => {
	try {
		const messages = window.top?.__rovoStreamResponseMessages__ ?? [];
		return messages.join('\n');
	} catch {
		// Ignore cross-origin frame access errors
		return '';
	}
};
